/**
 * ArbiHunter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: ROOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class CreatePageJsonBlockTranslationDto {
    /**
    * Title of the page block translation
    */
    'title': string;
    /**
    * Meta information for the translation
    */
    'meta'?: any;
    /**
    * Language code for the translation
    */
    'languageCode': CreatePageJsonBlockTranslationDtoLanguageCodeEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "title",
            "baseName": "title",
            "type": "string",
            "format": ""
        },
        {
            "name": "meta",
            "baseName": "meta",
            "type": "any",
            "format": "json"
        },
        {
            "name": "languageCode",
            "baseName": "languageCode",
            "type": "CreatePageJsonBlockTranslationDtoLanguageCodeEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return CreatePageJsonBlockTranslationDto.attributeTypeMap;
    }

    public constructor() {
    }
}

export enum CreatePageJsonBlockTranslationDtoLanguageCodeEnum {
    AF = 'af',
    AK = 'ak',
    AM = 'am',
    AR = 'ar',
    AS = 'as',
    AZ = 'az',
    BE = 'be',
    BG = 'bg',
    BM = 'bm',
    BN = 'bn',
    BO = 'bo',
    BR = 'br',
    BS = 'bs',
    CA = 'ca',
    CE = 'ce',
    CO = 'co',
    CS = 'cs',
    CU = 'cu',
    CY = 'cy',
    DA = 'da',
    DE = 'de',
    DE_AT = 'de_AT',
    DE_CH = 'de_CH',
    DZ = 'dz',
    EE = 'ee',
    EL = 'el',
    EN = 'en',
    EN_AU = 'en_AU',
    EN_CA = 'en_CA',
    EN_GB = 'en_GB',
    EN_US = 'en_US',
    EO = 'eo',
    ES = 'es',
    ES_ES = 'es_ES',
    ES_MX = 'es_MX',
    ET = 'et',
    EU = 'eu',
    FA = 'fa',
    FA_AF = 'fa_AF',
    FF = 'ff',
    FI = 'fi',
    FO = 'fo',
    FR = 'fr',
    FR_CA = 'fr_CA',
    FR_CH = 'fr_CH',
    FY = 'fy',
    GA = 'ga',
    GD = 'gd',
    GL = 'gl',
    GU = 'gu',
    GV = 'gv',
    HA = 'ha',
    HE = 'he',
    HI = 'hi',
    HR = 'hr',
    HT = 'ht',
    HU = 'hu',
    HY = 'hy',
    IA = 'ia',
    ID = 'id',
    IG = 'ig',
    II = 'ii',
    IS = 'is',
    IT = 'it',
    JA = 'ja',
    JV = 'jv',
    KA = 'ka',
    KI = 'ki',
    KK = 'kk',
    KL = 'kl',
    KM = 'km',
    KN = 'kn',
    KO = 'ko',
    KS = 'ks',
    KU = 'ku',
    KW = 'kw',
    KY = 'ky',
    LA = 'la',
    LB = 'lb',
    LG = 'lg',
    LN = 'ln',
    LO = 'lo',
    LT = 'lt',
    LU = 'lu',
    LV = 'lv',
    MG = 'mg',
    MI = 'mi',
    MK = 'mk',
    ML = 'ml',
    MN = 'mn',
    MR = 'mr',
    MS = 'ms',
    MT = 'mt',
    MY = 'my',
    NB = 'nb',
    ND = 'nd',
    NE = 'ne',
    NL = 'nl',
    NL_BE = 'nl_BE',
    NN = 'nn',
    NY = 'ny',
    OM = 'om',
    OR = 'or',
    OS = 'os',
    PA = 'pa',
    PL = 'pl',
    PS = 'ps',
    PT = 'pt',
    PT_BR = 'pt_BR',
    PT_PT = 'pt_PT',
    QU = 'qu',
    RM = 'rm',
    RN = 'rn',
    RO = 'ro',
    RO_MD = 'ro_MD',
    RU = 'ru',
    RW = 'rw',
    SA = 'sa',
    SD = 'sd',
    SE = 'se',
    SG = 'sg',
    SI = 'si',
    SK = 'sk',
    SL = 'sl',
    SM = 'sm',
    SN = 'sn',
    SO = 'so',
    SQ = 'sq',
    SR = 'sr',
    ST = 'st',
    SU = 'su',
    SV = 'sv',
    SW = 'sw',
    SW_CD = 'sw_CD',
    TA = 'ta',
    TE = 'te',
    TG = 'tg',
    TH = 'th',
    TI = 'ti',
    TK = 'tk',
    TO = 'to',
    TR = 'tr',
    TT = 'tt',
    UG = 'ug',
    UK = 'uk',
    UR = 'ur',
    UZ = 'uz',
    VI = 'vi',
    VO = 'vo',
    WO = 'wo',
    XH = 'xh',
    YI = 'yi',
    YO = 'yo',
    ZH = 'zh',
    ZH_HANS = 'zh_Hans',
    ZH_HANT = 'zh_Hant',
    ZU = 'zu'
}

